import {GalleryItem} from "../Gallery";

export const gallery2025Items: GalleryItem[] = [
    "/static/Gallery/2025/Foto-149.jpg",
    "/static/Gallery/2025/Foto-129.jpg",
    "/static/Gallery/2025/Foto-130.jpg",
    "/static/Gallery/2025/Foto-131.jpg",
    "/static/Gallery/2025/Foto-134.jpg",
    "/static/Gallery/2025/Foto-140.jpg",
    "/static/Gallery/2025/Foto-142.jpg",
    "/static/Gallery/2025/Foto-144.jpg",
    "/static/Gallery/2025/Foto-126.jpg",
    "/static/Gallery/2025/1_Foto-1.jpg",
    "/static/Gallery/2025/1_Foto-4.jpg",
    "/static/Gallery/2025/1_Foto-6.jpg",
    "/static/Gallery/2025/1_Foto-9.jpg",
    "/static/Gallery/2025/1_Foto-13.jpg",
    "/static/Gallery/2025/1_Foto-15.jpg",
    "/static/Gallery/2025/1_Foto-29.jpg",
    "/static/Gallery/2025/1_Foto-33.jpg",
    "/static/Gallery/2025/1_Foto-35.jpg",
    "/static/Gallery/2025/1_Foto-38.jpg",
    "/static/Gallery/2025/1_Foto-42.jpg",
    "/static/Gallery/2025/1_Foto-43.jpg",
    "/static/Gallery/2025/1_Foto-49.jpg",
    "/static/Gallery/2025/1_Foto-57.jpg",
    "/static/Gallery/2025/1_Foto-62.jpg",
    "/static/Gallery/2025/1_Foto-64.jpg",
    "/static/Gallery/2025/1_Foto-71.jpg",
    "/static/Gallery/2025/1_Foto-72.jpg",
    "/static/Gallery/2025/1_Foto-76.jpg",
    "/static/Gallery/2025/2_Foto-1.jpg",
    "/static/Gallery/2025/2_Foto-4.jpg",
    "/static/Gallery/2025/2_Foto-8.jpg",
    "/static/Gallery/2025/2_Foto-9.jpg",
    "/static/Gallery/2025/2_Foto-13.jpg",
    "/static/Gallery/2025/2_Foto-18.jpg",
    "/static/Gallery/2025/2_Foto-19.jpg",
    "/static/Gallery/2025/2_Foto-22.jpg",
    "/static/Gallery/2025/2_Foto-29.jpg",
    "/static/Gallery/2025/2_Foto-32.jpg",
    "/static/Gallery/2025/2_Foto-38.jpg",
    "/static/Gallery/2025/2_Foto-39.jpg",
    "/static/Gallery/2025/2_Foto-47.jpg",
    "/static/Gallery/2025/2_Foto-59.jpg",
    "/static/Gallery/2025/2_Foto-72.jpg",
    "/static/Gallery/2025/2_Foto-73.jpg",
    "/static/Gallery/2025/2_Foto-77.jpg",
    "/static/Gallery/2025/Foto-2.jpg",
    "/static/Gallery/2025/Foto-4.jpg",
    "/static/Gallery/2025/Foto-6.jpg",
    "/static/Gallery/2025/Foto-10.jpg",
    "/static/Gallery/2025/Foto-13.jpg",
    "/static/Gallery/2025/Foto-15.jpg",
    "/static/Gallery/2025/Foto-21.jpg",
    "/static/Gallery/2025/Foto-22.jpg",
    "/static/Gallery/2025/Foto-27.jpg",
    "/static/Gallery/2025/Foto-33.jpg",
    "/static/Gallery/2025/Foto-38.jpg",
    "/static/Gallery/2025/Foto-39.jpg",
    "/static/Gallery/2025/Foto-40.jpg",
    "/static/Gallery/2025/Foto-50.jpg",
    "/static/Gallery/2025/Foto-53.jpg",
    "/static/Gallery/2025/Foto-58.jpg",
    "/static/Gallery/2025/Foto-60.jpg",
    "/static/Gallery/2025/Foto-62.jpg",
    "/static/Gallery/2025/Foto-64.jpg",
    "/static/Gallery/2025/Foto-77.jpg",
    "/static/Gallery/2025/Foto-78.jpg",
    "/static/Gallery/2025/Foto-84.jpg",
    "/static/Gallery/2025/Foto-88.jpg",
    "/static/Gallery/2025/Foto-89.jpg",
    "/static/Gallery/2025/Foto-91.jpg",
    "/static/Gallery/2025/Foto-97.jpg",
    "/static/Gallery/2025/Foto-98.jpg",
    "/static/Gallery/2025/Foto-100.jpg",
    "/static/Gallery/2025/Foto-102.jpg",
    "/static/Gallery/2025/Foto-109.jpg",
    "/static/Gallery/2025/Foto-113.jpg",
    "/static/Gallery/2025/Foto-114.jpg",
    "/static/Gallery/2025/Foto-117.jpg",
    "/static/Gallery/2025/Foto-118.jpg",
    "/static/Gallery/2025/Foto-123.jpg",
    "/static/Gallery/2025/Foto-124.jpg",
    "/static/Gallery/2025/Foto-125.jpg",
    "/static/Gallery/2025/Foto-151.jpg",
    "/static/Gallery/2025/Foto-156.jpg",
    "/static/Gallery/2025/Foto-159.jpg",
    "/static/Gallery/2025/Foto-165.jpg",

];
